import { h } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("div", {
  class: "countdown-gadge__title"
}, " 倒數 ", -1);

var _hoisted_2 = {
  class: "countdown-gadge__main"
};

var _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  class: "countdown-gadge__box countdown-gadge__box_narrow"
}, " : ", -1);

var _hoisted_4 = {
  class: "countdown-gadge__box"
};

var _hoisted_5 = /*#__PURE__*/_createVNode("div", {
  class: "countdown-gadge__box countdown-gadge__box_narrow"
}, " : ", -1);

var _hoisted_6 = {
  class: "countdown-gadge__box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", {
    ref: "refRoot",
    class: ["countdown-gadge", {
      'countdown-gadge_has-3digi': $setup.hh > 99,
      'countdown-gadge_small-countdown': $setup.cData.smallCountDown
    }]
  }, [_hoisted_1, _createVNode("div", _hoisted_2, [_createVNode("div", {
    class: ["countdown-gadge__box", [$setup.hh > 99 ? 'countdown-gadge__box_3digi' : '']]
  }, _toDisplayString($setup.hh > 999 ? 999 : $setup.hh), 3), _hoisted_3, _createVNode("div", _hoisted_4, _toDisplayString($setup.mm), 1), _hoisted_5, _createVNode("div", _hoisted_6, _toDisplayString($setup.ss), 1)])], 2);
}